import routes from '~/config/routes';
import api from '~/config/api';
import imageConfig from '~/config/imageConfig';
import webConfig from '~/config/webConfig';

const config = {
    routes,
    api,
    imageConfig,
    webConfig,
};

export default config;